import React from 'react';
import MenuLive from './live/MenuLive';
import MenuPrematch from './prematch/MenuPrematch';
import MenuPrematchAlt from './prematch/MenuPrematchAlt';
import { getConfiguration } from '../../data/utils';

function Menu(props) {


    const conf = getConfiguration();


    return (
        <>
            {props.isLive ?
                <MenuLive {...props} />
                :
                conf.iwh ? <MenuPrematchAlt {...props} /> : <MenuPrematch {...props} />
            }
        </>
    )
}

export default Menu;